import React, { Component } from 'react';
import withRouter from "../../Utils/withRouter";
import Swal from "sweetalert2";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { NoRecords } from '../../Components/Shimmer';
import { formatDate } from '../../Components/InputElements';
import { currentDateAndTime, decodeData } from '../../Constants/constants';

class EducationalDetails extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);

    // Initial state to store form data and validation errors
    this.state = {
      employee_degree: '',
      institute_university: '',
      year_of_passout: '',
      // percentage_grade: '',
      employee_qualification_document: '',
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      errors: {},
      education_status:"1",
      academic_score_value:"",
      academic_score_type:"1",
      employee_qualification_id:"",
      decodedData: [],
    };
    this.closeRef = React.createRef();
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }
  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log("e.target",name, value)
    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleRadioChange = (name, value) => {
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  

  // Handler function for Select component change
  handleSelectChange = (name, selectedOption) => {
    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: { ...prevState.errors, [name]: '', },
    }));
  };

  // Handler function for form submission
  handleSubmit = (e) => {
    e.preventDefault();
    const errors = this.validateForm();
    // if (Object.keys(errors).length > 0) {
    //   // If there are validation errors, update the state with the errors
    //   this.setState({ errors });
    //   return;
    // }
    const { apiURL, apiHeaderFile } = this.context;
    const headers = apiHeaderFile;
    const employee_id = this.props.params.employee_id;
    var formData = new FormData();

    // Appending data to the FormData object
    
    this.state.employee_qualification_id && employee_id && 
    formData.append('employee_qualification_id', this.state.employee_qualification_id);
    formData.append('employee_id', employee_id);
    formData.append('employee_degree', this.state.employee_degree);
    formData.append('institute_university', this.state.institute_university);
    formData.append('education_status', this.state.education_status);
    formData.append('year_of_passout', this.state.year_of_passout);
    formData.append('percentage_grade', this.state.percentage_grade);
    formData.append('academic_score_value', this.state.academic_score_value);
    formData.append('academic_score_type', this.state.academic_score_type);
    formData.append('employee_qualification_document', this.state.employee_qualification_document);
    formData.append('date',currentDateAndTime());
    console.log("form data", formData)
   
    axios.post(`${apiURL}Employees/CreateEmployeeQualification`, formData,{ headers })
    .then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({
          employee_qualification_id: '',
          employee_degree: '',
          institute_university: '',
          year_of_passout: '',
          academic_score_value: '',
          academic_score_type: '',
          employee_qualification_document: '',
          employee_qualification: '',
          percentage_grade: '',
          

        });
        this.closeRef.current.click();

        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
      }

    })
  };
  handleSelectFile = (e) => {
    const file = e.target.files[0];
    this.setState({
      employee_qualification_document: file,
      selectedFileName: file ? file.name : '',
    });
  };
  removeSelectedFile = () => {
    this.setState({
      employee_qualification_document: null,
      selectedFileName: '',
    });
  };
  handleEdit= (row)=>{
    this.setState({
      employee_qualification_id: row?.employee_qualification_id,
      employee_degree: row?.employee_degree,
      institute_university: row?.institute_university,
      education_status: row?.education_status,
      year_of_passout: row?.year_of_passout,
      // percentage_grade: row?.percentage_grade,
      academic_score_value: row?.academic_score_value,
      academic_score_type: row?.academic_score_type,
      employee_qualification_document: row?.employee_qualification_document,
    })
  }

  
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetEmployeeQualifications`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          employee_id: this.props.params.employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
            employee_degree: '',
            institute_university: '',
            year_of_passout: '',
            academic_score_value: '',
            academic_score_type: '',
            employee_qualification_document: '',
            employee_qualification: '',
            percentage_grade: '',
            errors:{},
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to Delete this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_qualification_id: id,
          date: currentDateAndTime(),
        };
        axios
          .post(`${apiURL}Employees/DeleteEmployeeQualification`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };

  // Custom validation function with regex
  validateForm = () => {
    const errors = {};
    const numberRegex = /^[0-9]+$/;
    const gradeRegex = /^[A-Z]+$/;
    const cgpaRegex = /^(10(\.0{1,2})?|[0-9](\.\d{1,2})?)$/;

    if (!this.state.institute_university) errors.institute_university = 'Institute or University is required';
    if (!this.state.employee_degree) errors.employee_degree = 'Degree is required';
    if (!this.state.education_status) errors.education_status = 'Education Status is required';
    if (this.state.education_status==="1" && !this.state.year_of_passout) errors.year_of_passout = 'Year of Passing is required';
 
  //   const { academic_score_type, academic_score_value } = this.state;
  //   if (!academic_score_type) {
  //   errors.academic_score_type = 'Score type is required';
  // } else if (!academic_score_value) {
  //   errors.academic_score_value = `Please enter your ${
  //     academic_score_type === '1'
  //       ? 'Percentage'
  //       : academic_score_type === '2'
  //       ? 'Grade': 'CGPA' }.`;
  // } else {
  //   if (academic_score_type === '1') {
  //     // Validate Percentage
  //     if (!numberRegex.test(academic_score_value) || academic_score_value < 0 || academic_score_value > 100) {
  //       errors.academic_score_value = 'Enter a valid percentage between 0 and 100.';
  //     }
  //   } else if (academic_score_type === '2') {
  //     // Validate Grade
  //     if (!gradeRegex.test(academic_score_value)) {
  //       errors.academic_score_value = 'Grade must contain uppercase letters only.';
  //     }
  //   } else if (academic_score_type === '3') {
  //     // Validate CGPA
  //     if (!cgpaRegex.test(academic_score_value)) {
  //       errors.academic_score_value = 'Enter a valid CGPA (e.g., 9.5 or 10.0).';
  //     }
  //   }
  // }

  return errors;
};


  // validate = () => {
  //   const errors = {};
  //   const numberRegex = /^[0-9]+$/;
  //   const gradeRegex = /^[A-Z]+$/; 
  //   const cgpaRegex = /^(10(\.0{1,2})?|[0-9](\.\d{1,2})?)$/; 
  
  //   if (this.state.scoreType === "Percentage") {
  //     if (!numberRegex.test(this.state.percentage_grade) || this.state.percentage_grade < 0 || this.state.percentage_grade > 100) {
  //       errors.percentage_grade = 'Enter a valid percentage between 0 and 100.';
  //     }
  //   } else if (this.state.scoreType === "Grade") {
  //     if (!gradeRegex.test(this.state.percentage_grade)) {
  //       errors.percentage_grade = 'Grade must be uppercase letters only.';
  //     }
  //   } else if (this.state.scoreType === "CGPA") {
  //     if (!cgpaRegex.test(this.state.percentage_grade)) {
  //       errors.percentage_grade = 'Enter a valid CGPA (e.g., 9.5 or 10.0).';
  //     }
  //   }
  
  //   return errors;
  // };

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList(); // This will log the updated state value
      }
    );
  };
  
  render() {
    const { errors } = this.state;

    return (
      <>
        <div className='d-flex justify-content-between align-itmes-center'>
          <h5> Educational Details </h5>
          <div>
            {/* Grids in modals */}
            <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#EducationalDetails" onClick={()=>this.GetList()}>
              <i className="ri-menu-add-fill" style={{ fontSize: "16px" }} />
              Add
            </button>
            <div className="modal fade" id="EducationalDetails" tabIndex={-1} aria-labelledby="exampleModalgridLabel" aria-modal="true">
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalgridLabel">Add Educational Details</h5>
                    <button type="button" className="btn-close" ref={this.closeRef} data-bs-dismiss="modal" aria-label="Close" />
                  </div>
                  <div className="modal-body">
                    <div className="container mt-2">
                      <form onSubmit={this.handleSubmit}>

                        <div className="row">

                          <div className="col-md-6 mb-3">
                            <label htmlFor="employee_degree" className="form-label">Qualification:</label>
                            <input
                              type="text"
                              id="employee_degree"
                              name="employee_degree"
                              value={this.state.employee_degree}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.employee_degree ? 'is-invalid' : ''}`}
                              placeholder="Enter Qualification:"
                            />
                            {errors.employee_degree && <div className="invalid-feedback">{errors.employee_degree}</div>}
                          </div>

                          <div className="col-md-6 mb-3">
                            <label htmlFor="institute_university" className="form-label">Institute/University:</label>
                            <input
                              type="text"
                              id="institute_university"
                              name="institute_university"
                              value={this.state.institute_university}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.institute_university ? 'is-invalid' : ''}`}
                              placeholder="Enter Institute/University"
                            />
                            {errors.institute_university && <div className="invalid-feedback">{errors.institute_university}</div>}
                          </div>
                        </div>
                        <div className="row">
                        <div className="col-md-6 mb-3">
                            <div>
                              <label htmlFor="is_Dependend" className="form-label">Education Status:<span
                              style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                              *
                            </span></label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="educationStatusYes"
                                name="education_status"
                                value="1"
                                checked={this.state.education_status === '1'}
                                onChange={() => this.handleRadioChange('education_status', '1')}
                                className={`form-check-input ${errors.education_status ? 'is-invalid' : ''}`}
                              />
                              <label htmlFor="educationStatusYes" className="form-check-label">Completed</label>
                              
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="educationStatusNo"
                                name="education_status"
                                value="2"
                                checked={this.state.education_status === '2'}
                                onChange={() => {this.handleRadioChange('education_status', '2'); this.setState({ year_of_passout:"" })}}
                                className={`form-check-input ${errors.education_status ? 'is-invalid' : ''}`}
                              />
                              <label htmlFor="educationStatusNo" className="form-check-label">Appearing</label>
                            </div>
                            {errors.education_status && <div className="text-danger">{errors.education_status}</div>}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="year_of_passout" className="form-label">Year Of {this.state.education_status==="1"?"Passout":"Passing"}:</label>
                            <input
                              type="date"
                              id="year_of_passout"
                              name="year_of_passout"
                              // disabled={this.state.education_status==="2"}
                              value={this.state.year_of_passout}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.year_of_passout ? 'is-invalid' : ''}`}
                              placeholder="Enter Year Of Passing"
                            />
                            {errors.year_of_passout && <div className="invalid-feedback">{errors.year_of_passout}</div>}
                          </div>
{/* 
                          <div className="col-md-6 mb-3">
                            <label htmlFor="percentage_grade" className="form-label">Academic Scores:</label>
                            <input
                              type="number"
                              id="percentage_grade"
                              name="percentage_grade"
                              value={this.state.percentage_grade}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.percentage_grade ? 'is-invalid' : ''}`}
                              placeholder="Enter Your Grade"
                            />
                            {errors.percentage_grade && <div className="invalid-feedback">{errors.percentage_grade}</div>}
                          </div> */}

                          <div className="row">
                            {/* Dropdown to select the score type */}
                            <div className="col-md-6 mb-3">
                              <label htmlFor="scoreType" className="form-label">Academic Scores:</label>
                              <select
                                id="scoreType"
                                name="scoreType"
                                className="form-select"
                                placeholder="Enter Your Academic Scores"
                                value={this.state.scoreType}
                                onChange={(e) => this.setState({ academic_score_type: e.target.value, academic_score_value: '' })} 
                              >
                                <option value="1">Percentage</option>
                                <option value="2">Grade</option>
                                <option value="3">CGPA</option>
                              </select>
                            </div>

                            {/* Input field displayed based on the selected score type */}
                          
                              <div className="col-md-6">
                                <label htmlFor="academicscore_value" className="form-label">
                            Enter Your  {this.state.academic_score_type === '1' 
                              ? 'Percentage' 
                              : this.state.academic_score_type === '2' 
                              ? 'Grade' 
                              : this.state.academic_score_type === '3' 
                              ? 'CGPA' 
                              : ''}
                          </label>

                                <input
                                  type="text"
                                  id="academicscore_value"
                                  disabled={!this.state.academic_score_type}
                                  name="academic_score_value"
                                  value={this.state.academic_score_value}
                                  onChange={this.handleInputChange}
                                  className={`form-control ${errors.academic_score_value ? 'is-invalid' : ''}`}
                                  placeholder={`Enter Your Academic Score ${this.state.academic_score_value? this.state.academic_score_value:""}`}  // This placeholder will dynamically change based on selected score type
                                />
                                {errors.academic_score_value && <div className="invalid-feedback">{errors.academic_score_value}</div>}
                              </div>

                          </div>


                          {/* <div className="col-md-6 mb-3">
                            <label htmlFor="employee_qualification_document" className="form-label">
                              Employee Qualification Document<span className='muted'>...(optional)</span>
                            </label>
                            <div>
                              <label htmlFor="employee_qualification_document" className="btn btn-primary mt-3">
                                Choose File
                              </label>
                            </div>
                            <input
                              type="file"
                              id="employee_qualification_document"
                              name="employee_qualification_document"
                              onChange={this.handleSelectFile}
                              className="form-control d-none"
                              placeholder="Enter Your Qualification Document"
                              accept="image/*,.pdf"
                            />
                            {this.state.selectedFileName && (
                              <div className="mt-2 d-flex align-items-center">
                                <span>Selected file: {this.state.selectedFileName}</span>
                                <button
                                  type="button"
                                  className="btn-close ms-2"
                                  aria-label="Close"
                                  onClick={this.removeSelectedFile}>
                                </button>
                              </div>
                            )}
                          </div> */}
                        </div>
                        <div className="d-flex justify-content-end">
                          <button type="submit" className={`btn btn-${this.state.employee_qualification_id? "primary":"success"} btn-label waves-effect right waves-light`}>
                            <i className="bx bx-save label-icon align-middle fs-16 ms-2" />{this.state.employee_qualification_id? "Update":"Save"} </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className={`table table-bordered table-stripped`}>
            <thead className="table-light">
              <tr>
                <th>Enter Qualification</th>
                <th>Institute</th>
                <th>Year Of Passing</th>
                <th>Academic Score</th>
                {/* <th>Qualification Document</th> */}

                <th className="text-center">Action</th>
              </tr>
            </thead>
            {
              this.state.rows?.length === 0?
              <tbody>
                    <tr>
                        <td colSpan={9}>
                            <NoRecords/>
                        </td>
                    </tr>
                </tbody>:
            <tbody>
              {this.state.rows.map((row) => {
                return (
                  <tr key={row?.employee_qualification_id}>
                    <td>{row?.employee_degree}</td>
                    <td>{row?.institute_university}</td>
                    <td>{row?.year_of_passout? formatDate(row?.year_of_passout):"--"}</td>
                    <td>
                      {row?.academic_score_value}{' '}
                      {row?.academic_score_type === '1'
                      ? '%'
                      : row?.academic_score_type === '2'
                      ? 'Grade'
                      : row?.academic_score_type === '3'
                      ? 'CGPA'
                      : ''}
                    </td>

                    {/* <td>
                      <div className='d-flex justify-content-center align-items-center'>
                        <a href={`${row.employee_qualification_document_url}`}
                          className={`${!row.employee_qualification_document_url ? ('d-none') : ''} link-info link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover`}
                          target="_blank" rel="noopener noreferrer">
                          View Uploaded Document
                        </a>
                      </div>
                    </td> */}
                    <td className="d-flex justify-content-around gap-2">
                    <button
                           onClick={() =>
                            this.handleEdit(row)
                            
                        }
                              data-bs-toggle="modal" data-bs-target="#EducationalDetails"
                                className="btn-icon btn btn-sm btn-outline-primary">
                                <i className="ri-edit-box-line"></i>
                          </button>
                      <button
                        onClick={() =>
                          this.handleDelete(row.employee_qualification_id)
                        }
                        className="btn-icon btn btn-sm btn-outline-danger"
                      >

                        <i className="ri-delete-bin-line"></i>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>}
            <tfoot className="table-light">
              <tr>
                <th colSpan={6}>
                  <div className="d-flex justify-content-between">
                    <button
                      disabled={
                        this.state.prev === false &&
                          this.state.loadingList === false
                          ? true
                          : false
                      }
                      type="button"
                      onClick={() => this.handlePrev()}
                      className={`btn btn-warning btn-label waves-effect waves-light`}
                    >
                      <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                      Previous
                    </button>
                    <div
                      className="col-md-4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {
                        <small>
                          Total Records: {this.state.total_records} |
                          Total Pages: {this.state.total_pages} |
                          Current Page: {this.state.page}
                        </small>
                      }
                    </div>
                    <div className="col-md-2">
                      <select
                        className="form-select"
                        onChange={(e) => this.handleChange(e)}
                      >
                        {Array.from(
                          { length: this.state.total_pages },
                          (_, i) => (
                            <option
                              selected={this.state.page === i + 1}
                              key={i}
                              value={i + 1}
                            >
                              Page {i + 1}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    <button
                      disabled={
                        this.state.next === false &&
                          this.state.loadingList === false
                          ? true
                          : false
                      }
                      type="button"
                      onClick={() => this.handleNext()}
                      className={`btn btn-primary btn-label waves-effect right waves-light`}
                    >
                      <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                      Next
                    </button>
                  </div>
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
      </>
    );
  }
}

export default withRouter(EducationalDetails);
